















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
    }
})
export default class VerifyPayroll extends Vue {
    //改变时间
    period: string[] = []; // 日期
    changeDate(date: string[], ) {
        this.period = date;
        this.fetchData();
    }
    shouldFetch: boolean = false
    // 获取数据
    checkList: Salary.CheckSalary[] = []
    fetchData() {
        this.shouldFetch = false;
        Vue.axios
            .get(
                `paysheet/templates?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`)
            .then(res => {
                this.checkList = res.data
            });
    }
}
